import React, {
  useState, useEffect, useRef, useMemo,
} from 'react';
import MaterialTable, { MTableBody } from 'material-table';

import '../../../../pages/p2p/P2p.less';
import MTableHeader from '../../../material-table-overrides/MTableHeader';
import MTableFilterRow from '../../../material-table-overrides/MTableFilterRow';
import TooltippedElement from '../../../common/TooltippedElement';
import { mapDtoToTable } from '../../../../dto/p2p';
import { styledTableHeading, tableIcons } from '../../../../helpers';
import { localization, modifyDefaultOptions } from '../../../../helpers/table';
import useAPI from '../../../../hooks/useAPI';
import {
  getFooter, getHeader, getYearRelatedColumns, prefilterTableData,
} from '../../helpers/IndexTableHelper';
import ToolbarWrapper from '../../../table/ToolbarWrapper';

const DEFAULT_YEAR = Number(DEFAULT_YEAR_WEBPACK);

export default function StratIndexP2p(props) {
  const [data, setData] = useState([]);
  const [filterYears, setFilterYears] = useState([DEFAULT_YEAR]);
  const [filterFunding, setFilterFunding] = useState(['base', 'special']);

  const api = useAPI();

  useEffect(async () => {
    const respProjResults = await api.get(`/reports/strategies/${props.strategyId}/projresults`);
    const mappedTableData = mapDtoToTable(respProjResults).filter((v) => !v.parentId);
    setData(mappedTableData);
  }, []);

  const prefilteredData = useMemo(() => prefilterTableData(data, filterYears), [data, filterYears]);

  const getColumns = () => {
    const colsStart = [
      {
        title: 'Мероприятие Постановления №729',
        field: 'id',
        defaultSort: 'asc',
        filterCellStyle: { maxWidth: '300px', width: '4%' },
        width: '5%',
        render: (rowData) => (!rowData.parentId
          ? (<TooltippedElement tooltip={rowData.descr}><span style={{ fontSize: '16px' }}>{rowData.name}</span></TooltippedElement>)
          : ''),
        customFilterAndSearch: (term, rowData) => term.length === 0
          || (!rowData.parentId && term.toLowerCase().indexOf(rowData.name.toLowerCase()) >= 0)
          || (rowData.parentId && term.toLowerCase().indexOf(rowData.parentId.toLowerCase()) >= 0),
      },
    ];

    const colsMiddle = getYearRelatedColumns(filterYears, filterFunding);

    return [...colsStart, ...colsMiddle];
  };

  return (
    <div className="tab-index p2p-page">
      <MaterialTable
        options={modifyDefaultOptions({
          // tableLayout: 'fixed',
          paging: false,
          draggable: false,
          search: false,
          rowStyle: (rowData) => ({
            backgroundColor: !rowData.parentId ? '#FFF' : '#F7F7FF',
          }),
          headerStyle: { height: 102, fontSize: '13px' },
        })}
        icons={tableIcons}
        localization={localization}
        columns={getColumns()}
        data={prefilteredData}
        title={(
          <>
            <h3 style={styledTableHeading}>
              {props.type === 'strategy' 
                ? 'Детализация показателя ПРГ2' 
                : 'Детализация показателя «Количество реализованных проектов, в том числе с участием членов консорциума (консорциумов)»'
              }
            </h3>
            Общее количество реализованных проектов, в том числе с участием членов консорциума (консорциумов), по каждому из мероприятий программ развития, указанных в пункте 5 Правил проведения отбора, ед.
          </>
)}
        components={{
          Header: (props) => (<MTableHeader {...props} tableHeadStyle={styledHeaderSticky}>{getHeader(filterYears, filterFunding)}</MTableHeader>),
          FilterRow: (props) => (<MTableFilterRow {...props} />),
          Toolbar: (nativeProps) => (
            <ToolbarWrapper
              nativeProps={nativeProps}
              filters={{
                yearsProps: { selectedYears: filterYears, onChange: setFilterYears },
                fundingProps: { selectedFundings: filterFunding, onChange: setFilterFunding },
              }}
            />
          ),
          Body: (props) => (
            <>
              <MTableBody {...props} />
              { getFooter(props, filterYears, filterFunding) }
            </>
          ),
        }}
      />
    </div>
  );
}

const styledHeaderSticky = { position: 'sticky', top: 0, zIndex: 10 };
